<template>

    <section class="justify-content-center mb-4">
        <div class="col-md-12 mx-auto py-2">
            <table class="mx-auto" style="width:100%;">
                <thead>
                    <tr>
                        <th  class="px-2">
                            <input type="text"
                                style="font-size:11px; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3; width:100%;"

                                :placeholder="__('traductionview.searchpointcontact')"
                                v-model="filtername"
                                @change="onFilterNameChange()">
                        </th>
                        <th  class="px-2">
                            <input type="text"
                                style="font-size:11px; border:1px solid #3A9AF3; border-radius:5px; color:#3A9AF3; width:100%;"

                                :placeholder="__('traductionview.searchcompanyname')"
                                v-model="filterproject"
                                @change="onFilterProjectChange()">
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="col-md-12 mx-auto dashboardstyle pt-0">
            <table class="mx-auto text-center abc-table" style="width: 100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom:solid 1px #3A9AF3;">
                        <th style="vertical-align: middle; width: 15%;">
                            {{__("traductionpro.entrepri")}}
                             <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="companySortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="companySortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th class="py-3" style="vertical-align: middle; width: 10%;">
                             {{__("traductionpro.nomnom")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="projectSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="projectSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="vertical-align: middle; width: 25%;">
                             {{__("traductionpro.email")}}
                        </th>
                        <th style="vertical-align: middle; width: 10%;">
                            {{__("traductionpro.accountmanager")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="staffSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="staffSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="vertical-align: middle; width: 10%;">
                            {{__("traductionpro.presence")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="presenceSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="presenceSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="vertical-align: middle; width: 10%;">
                            {{__("traductionpro.acquisition")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="acquisitionSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="acquisitionSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="vertical-align: middle; width: 10%;">
                             {{__("traductionpro.ongoingproject")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="ongoingSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="ongoingSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                        <th style="vertical-align: middle; width: 10%;">
                            {{__("traductionpro.finishedproject")}}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="finishedSortAsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                    <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="finishedSortDsc">
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="rgb(107, 107, 107)" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                </svg>
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody id="ongoingproject" style="font-size: 11px; overflow:auto; display:block; max-height:600px;">
                    <tr v-for="(customer, index) in customs" :key="index" style="border-bottom:solid 1px rgb(206,206,206);">
                        <td style="vertical-align: middle; width: 15%;">
                            {{ customer.client_name }}
                        </td>
                        <td class="py-3" style="vertical-align: middle; width: 10%;">
                            <a :href="'/app/home/manager/'+country.id+'/modify/pointofcontact/' + customer.id">
                                <p class="mb-0">{{ customer.name }}</p>
                            </a>
                        </td>
                        <td class="px-3" style="vertical-align: middle; width: 25%;">
                            {{ customer.email }}
                        </td>
                        <td v-if="user.admin==1" style="vertical-align: middle; width: 10%; font-weight: bold;">
                            <div v-if="customer.staff_assigned_name">
                                <a :href="'/app/manager/'+country.id+'/staff_assigned/' + customer.id">
                                    <p class="mb-0">{{ customer.staff_assigned_name }} </p>
                                </a>
                            </div>
                            <div v-else>
                                <a :href="'/app/manager/'+country.id+'/staff_assigned/' + customer.id">
                                    <p class="mb-0"> {{__("traductionview.miseajour")}}</p>
                                </a>
                            </div>
                        </td>
                        <td v-else style="vertical-align: middle; width: 10%;">
                            <p class="mb-0">{{ customer.staff_assigned_name }} </p>
                        </td>
                        <td style="vertical-align: middle; width: 10%;">
                            <p class="mb-0">{{ customer.country_presence }}</p>
                        </td>
                        <td style="vertical-align: middle; width: 10%;">
                            <p class="mb-0">{{ customer.hear_about }}</p>
                        </td>
                        <td style="vertical-align: middle; width: 10%;">
                            <p class="mb-0">{{ customer.ongoing_projects }}</p>
                        </td>
                        <td style="vertical-align: middle; width: 10%;">
                            <p class="mb-0">{{ customer.finished_projects }}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>

</template>

<script>
    export default {
        props: [
            'contacts',
            'country',
            'user',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                filterproject:"",
                filterstatus:"",
            }
        },

        mounted() {
            this.contacts.forEach(customer =>
            {
                this.customs.push(customer)
            });
        },


        methods: {
             onFilterNameChange(){
                this.customs=[];
                this.contacts.forEach(customer =>
                {
                    var search = customer.name.toLowerCase()
                    if (search.includes(this.filtername.toLowerCase()))
                    {
                        this.customs.push(customer);
                    }
                });

            },
            onFilterProjectChange(){
                this.customs=[];
                this.contacts.forEach(customer =>
                {
                    var search = customer.client_name.toLowerCase()
                    if (search.includes(this.filterproject.toLowerCase()))
                    {
                        this.customs.push(customer);
                    }
                });

            },
            projectSortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.name < b.name)
                    {
                        return -1;
                    }
                    else if (a.name > b.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            projectSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.name > b.name)
                    {
                        return -1;
                    }
                    else if (a.name < b.name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            companySortAsc(){

                this.customs = this.customs.sort(function(a, b){
                    if (a.client_name < b.client_name)
                    {
                        return -1;
                    }
                    else if (a.client_name > b.client_name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            companySortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.client_name > b.client_name)
                    {
                        return -1;
                    }
                    else if (a.client_name < b.client_name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            staffSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.staff_assigned_name < b.staff_assigned_name)
                    {
                        return -1;
                    }
                    else if (a.staff_assigned_name > b.staff_assigned_name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            staffSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.staff_assigned_name > b.staff_assigned_name)
                    {
                        return -1;
                    }
                    else if (a.staff_assigned_name < b.staff_assigned_name)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            ongoingSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.ongoing_projects < b.ongoing_projects)
                    {
                        return -1;
                    }
                    else if (a.ongoing_projects > b.ongoing_projects)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            ongoingSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.ongoing_projects > b.ongoing_projects)
                    {
                        return -1;
                    }
                    else if (a.ongoing_projects < b.ongoing_projects)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            presenceSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.country_presence < b.country_presence)
                    {
                        return -1;
                    }
                    else if (a.country_presence > b.country_presence)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            presenceSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.country_presence > b.country_presence)
                    {
                        return -1;
                    }
                    else if (a.country_presence < b.country_presence)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            acquisitionSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.hear_about < b.hear_about)
                    {
                        return -1;
                    }
                    else if (a.hear_about > b.hear_about)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            acquisitionSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.hear_about > b.hear_about)
                    {
                        return -1;
                    }
                    else if (a.hear_about < b.hear_about)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            finishedSortAsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.finished_projects < b.finished_projects)
                    {
                        return -1;
                    }
                    else if (a.finished_projects > b.finished_projects)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
            finishedSortDsc(){
                this.customs = this.customs.sort(function(a, b){
                    if (a.finished_projects > b.finished_projects)
                    {
                        return -1;
                    }
                    else if (a.finished_projects < b.finished_projects)
                    {
                        return 1;
                    }
                    else
                    {
                        return 0;
                    }
                });
            },
    }
}

</script>
